import { render, staticRenderFns } from "./TrialExpiredDialog.vue?vue&type=template&id=54140b52&scoped=true&"
import script from "./TrialExpiredDialog.vue?vue&type=script&lang=js&"
export * from "./TrialExpiredDialog.vue?vue&type=script&lang=js&"
import style0 from "./TrialExpiredDialog.vue?vue&type=style&index=0&id=54140b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54140b52",
  null
  
)

export default component.exports